import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Colours from '../../definitions/Colours';


function IconPhone({ outlineWidth, stroke, strokeWidth, fill, ...otherProps }) {
    return (
        <IconPhone.Svg
            viewBox="0 0 62 62"
            outlineWidth={outlineWidth}
            strokeColour={stroke}
            strokeWidth={strokeWidth}
            fillColour={fill}
            {...otherProps}
        >
            <circle
                cx="31"
                cy="31"
                r="29"
            />
            <path
                d="M44.83 21.66l-3.69-4.31-.03-.02c-1.88-1.88-8.65 1.84-15.21 8.4-6.56
                6.56-10.43 13.48-8.56 15.36l.03.03 4.32 3.68 5.3-6.27-2.89-4.34
                10.12-10.12 4.34 2.89 6.27-5.3z"
            />
        </IconPhone.Svg>
    );
}

IconPhone.propTypes = {
    outlineWidth: PropTypes.string,
    stroke: PropTypes.oneOf(
        Object.values(Colours),
    ),
    strokeWidth: PropTypes.string,
    fill: PropTypes.oneOf(
        Object.values(Colours),
    ),
};

IconPhone.defaultProps = {
    outlineWidth: '2px',
    stroke: Colours.BLACKBERRY,
    strokeWidth: '2px',
    fill: Colours.TRANSPARENT,
};

IconPhone.Svg = styled.svg`
    transform: rotate(-90deg);
    transform-origin: 50% 50%;

    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-width: ${props => props.strokeWidth};
    stroke: ${props => props.strokeColour};
    fill: ${props => props.fillColour};

    circle {
        stroke-width: ${props => props.outlineWidth};
    }

    transition:
        stroke 300ms ease,
        fill 300ms ease;
`;

export default IconPhone;
